import { useState } from 'react';
import { RunButton, InfoCard, NoResult, AiAdvisor } from './common';
import { api } from '@/lib/api';
import { APP } from '@/constants/testIds';
import { toast } from 'sonner';

const Harvest = ({ farm, selectedCrop, crops, year, season }) => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const label = crops.find(c => c.key === selectedCrop)?.label;

  const run = async () => {
    setLoading(true);
    try { setResult(await api.harvest({ crop_key: selectedCrop, lat: farm.lat, lon: farm.lon, year, season })); }
    catch (e) { toast.error('Harvest advisory failed'); }
    finally { setLoading(false); }
  };

  return (
    <InfoCard title={`Harvest Readiness Assessment · ${label}`}
              subtitle="DAS-based maturity status + field maturity indicators + 5-day rain-forecast harvest-risk check.">
      <RunButton testId={APP.actions.runHarvest} onClick={run} loading={loading}>Check readiness</RunButton>
      {!result && !loading && <div className="mt-4"><NoResult /></div>}
      {result && (
        <div className="mt-5 space-y-4 animate-fade-up">
          <div className="p-4 rounded-lg bg-icrisat-green-soft/70 border border-icrisat-green/20">
            <div className="font-display text-lg text-icrisat-green">{result.status}</div>
            <div className="text-sm text-icrisat-earth mt-1">
              DAS today: <b>{result.das_today}</b> · Window: {result.window_start} → {result.window_end}
              &nbsp;(DAS {result.maturity_window_das[0]} - {result.maturity_window_das[1]})
            </div>
          </div>

          <Section title="Field maturity indicators" items={result.indicators} />
          <Section title="Post-harvest handling" items={result.post_harvest} />

          <Row label="Quick test" value={result.quick_test} />
          <Row label="Target moisture" value={result.harvest_moisture} />
          <Row label="Best time" value={result.best_time} />
          <Row label="Weather precaution" value={result.weather_precaution} />
          <Row label="Delay risk" value={result.delay_risk} />

          {result.weather_note && (
            <div className="p-3 rounded-lg bg-icrisat-mustard/20 border border-icrisat-mustard/40 text-sm">
              {result.weather_note}
            </div>
          )}

          <AiAdvisor context="harvest" payload={result} />
        </div>
      )}
    </InfoCard>
  );
};

const Section = ({ title, items }) => (
  <div>
    <h4 className="font-medium text-icrisat-green mb-1">{title}</h4>
    <ul className="list-disc list-inside space-y-1 text-sm">
      {items?.map((x, i) => <li key={i}>{x}</li>)}
    </ul>
  </div>
);

const Row = ({ label, value }) => (
  <div className="text-sm">
    <b className="text-icrisat-green">{label}: </b>
    <span className="text-icrisat-ink/85">{value}</span>
  </div>
);

export default Harvest;
